export const boxShadow = (addedToComposeDoc, selected) => {
  if (addedToComposeDoc) return 'rgb(46, 178, 67) 0px 5px 15px 0px, rgb(46, 178, 67) 0px 0px 0px 0px, rgb(46, 178, 67) 0px 0px 7px 0px';
  else if (selected) return 'rgb(255, 170, 51) 0px 3px 7px -2px, rgb(255, 170, 51) 0px 0px 0px 0px, rgb(255, 170, 51) 0px 0px 5px 0px';

  return '';
};
